<!--  -->
<template>
  <div>
    <template>
      <div class="select_boxr">
        <div class="search_box">
          <el-input
            v-model="query.keywords"
            clearable
            style="width:400px;"
            placeholder="请输入企业名称或id"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchclick"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="rechargeclick"
          >重置</el-button>
        </div>
        <el-button plain class="addbutton" type="primary" @click="addConfig">添加</el-button>
      </div>

    </template>
    <template>
      <el-table :cell-style="{ 'text-align': 'center' }" border :data="ChatList" style="width: 100%" :header-cell-style="rowClass">
        <el-table-column align="center" prop="corp_name" label="企业" width="180" />
        <el-table-column align="center" prop="type" label="类型" width="120">
          <template slot-scope="scope">
            {{ scope.row.type == '1' ? '个人' : '群聊' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="聊天次数" width="180">
          <template slot-scope="scope"> {{ scope.row.chat_num_min }}<span style="margin: 5px">---</span>{{ scope.row.chat_num_max }} </template>
        </el-table-column>
        <el-table-column align="center" label="回复间隔时间" width="180">
          <template slot-scope="scope"> {{ scope.row.reply_interval_min | filterdate }}<span style="margin: 5px">---</span>{{ scope.row.reply_interval_max | filterdate }} </template>
        </el-table-column>
        <el-table-column align="center" label="交流时间">
          <template slot-scope="scope"> {{ scope.row.communication_hour_min }}<span style="margin: 5px">---</span>{{ scope.row.communication_hour_max }} </template>
        </el-table-column>
        <el-table-column align="center" prop="proportion_personnel" label="人数比例" />
        <el-table-column align="center" width="300px" prop="user_str" label="人员配置">
          <template slot-scope="scope">
            <div class="column-content">
              <span v-for="item in scope.row.user_str" :key="item.id" class="name-item">{{ item.name }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="group_type" label="群类型">
          <template slot-scope="scope">
            {{ scope.row.group_type == '1' ? '内部' : scope.row.group_type == '2' ? '客户' : '' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="group_room_str" label="内部群" /> -->
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <div style="position: relative; display: inline-block">
              <el-switch v-model="scope.row.status" :width="50" active-color="#13ce66" inactive-color="rgb(191,191,191)" :active-value="1" :inactive-value="2" @change="changewr($event, scope.row)" />
              <div v-if="scope.row.status === 1" style="color: #fff; position: absolute; top: 2px; left: 7px">是</div>
              <div v-else style="color: #fff; position: absolute; top: 2px; right: 7px">否</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="conclusion"
          label="结束语"
        /> -->
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" style="margin-bottom: 10px" @click="editConfig(scope)">编辑</el-button>
            <el-button type="danger" size="mini" style="margin-bottom: 10px" @click="deleteConfig(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right style="padding: 0px; margin-top: 20px" :total="qrtotal" :current-page="query.page" :page-size="query.page_size" :page-sizes="[10, 50, 100]" @size-change="fetchPageSizeone" @current-change="fetchCurrentPageone" />
    </template>
    <el-dialog :title="{ add: '添加', edit: '编辑' }[mode]" :visible.sync="configshow" :append-to-body="true" :destroy-on-close="true" :close-on-click-modal="false" width="50%" @close="closeEvent">
      <el-form ref="form" :validate-on-rule-change="false" label-width="70px" :model="form" :rules="rules">
        <el-form-item label="企业">
          <template>
            <el-tag v-if="corp_name != ''" style="margin-right: 10px">{{ corp_name }}({{ corp_ids }})</el-tag>
            <el-button type="primary" size="mini" @click="chooseEnterprise">选择</el-button>
          </template>
        </el-form-item>
        <el-form-item prop="type" label="类型">
          <el-select v-model="form.type" :disabled="showload === false" placeholder="选择类型">
            <el-option label="个人" selected value="1" />
            <el-option label="群聊" value="2" disabled />
          </el-select>
        </el-form-item>
        <el-form-item label="是否在线员工 ">
          <el-select v-model="script_online" placeholder="选择类型">
            <el-option label="否" selected :value="1" />
            <el-option label="是" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="聊天次数">
          <el-col :span="6">
            <el-form-item prop="chat_num_min">
              <el-input v-model="form.chat_num_min" v-numericonly placeholder="请输入数字" />
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">
            <span style="margin: 0 6px">---</span>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="chat_num_max">
              <el-input v-model="form.chat_num_max" v-numericonly placeholder="请输入数字" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="回复间隔时间">
          <el-form-item prop="reply_interval_min" style="margin-bottom: 20px">
            <date :changedate="changedate" :houroptions="houroptions" :minutesoptions="minutesoptions" :secondsoptions="secondsoptions" :type="1" :formatreply_interval_min="formatreply_interval_min" :formatreply_interval_max="formatreply_interval_max" />
          </el-form-item>
          <el-form-item prop="reply_interval_max">
            <date :changedate="changedate" :houroptions="houroptions" :minutesoptions="minutesoptions" :secondsoptions="secondsoptions" :type="2" :formatreply_interval_min="formatreply_interval_min" :formatreply_interval_max="formatreply_interval_max" />
          </el-form-item>
        </el-form-item>
        <el-form-item label="交流时间">
          <el-col :span="6">
            <el-form-item prop="communication_hour_min">
              <el-input v-model="form.communication_hour_min" v-numericonly placeholder="请输入数字" />
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">
            <span style="margin: 0 6px">---</span>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="communication_hour_max">
              <el-input v-model="form.communication_hour_max" v-numericonly placeholder="请输入数字" />
            </el-form-item> </el-col><span style="margin: 2px">点</span>
        </el-form-item>
        <el-form-item v-if="form.type !== '2' && form.type !== '群聊'" class="frame" prop="proportion_personnel" label="人数比例">
          <div class="conter">
            <el-input v-model="form.proportion_personnel" v-numericonly value="10" style="width: 200px" />
            <div>%</div>
          </div>
        </el-form-item>
        <!-- <el-form-item
          v-if="form.type!=='2' && form.type!=='群聊'"
          class="frame"
          prop="conclusion"
          label="结束语"
        >
          <el-input
            v-model="form.conclusion"
            :maxlength="500"
            resize="none"
            type="textarea"
          />
        </el-form-item> -->
        <div>
          <el-form-item v-if="form.type !== '1' && form.type !== '个人'" prop="group_type" label="群类型">
            <el-select v-model="form.group_type" placeholder="选择类型" :collapse-tags="true">
              <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled || false" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.type !== '1' && form.type !== '个人'" prop="group_room" label="内部群">
            <el-select v-model="form.group_room" filterable multiple placeholder="选择类型">
              <el-option v-for="items in selectTypeList" :key="items.value" :label="items.label" :value="items.value" />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div v-if="form.type === '1' && corp_ids != ''" style="display: flex; margin-left: 70px">
        <div>
          <el-checkbox v-model="fullName" style="margin-bottom: 15px" @change="whole">全选</el-checkbox>
          <div class="checkbox-list">
            <div v-for="(item, index) in arr" :key="item.id" class="checkbox-item">
              <el-checkbox v-model="item.checked" @click.native.stop @change="itenclick(item, index)">{{ item.label }}</el-checkbox>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div class="vertical-line" />
          <div>
            <div>
              <div style="margin-bottom: 15px">选中的员工</div>
              <el-tag v-for="(tag, index) in arrs" :key="tag.user_id" closable style="margin-right: 10px; margin-bottom: 5px" :type="tag.type" @close="rightclick(tag.user_id, index)">
                {{ tag.name }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <pagination-right v-if="form.type === '1' && corp_ids != ''" style="padding: 0px; margin-top: 20px" :total="total" :current-page="pages.page" :page-size="pages.pageSize" :page-sizes="[10, 50, 100]" @size-change="fetchPageSize" @current-change="fetchCurrentPage" />
      <div class="que_box">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="configshow = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择企业" :visible.sync="dialogVisibleenterprise" :destroy-on-close="true">
      <chhosewechatqiwei ref="chhosewechatqiweiview" @callbackqiwei="callbackqiwei" />
    </el-dialog>
  </div>
</template>

<script>
import { spWorkWechatSpCorpChatConfigAdd, spWorkWechatSpCorpChatConfigUpdate, spWorkWechatSpCorpChatConfigDel, spWorkWechatSpCorpInternalGroupList, spWorkWechatSpCorpChatConfigSetStatus, spWorkWechatspCorpindexForWw } from '@/api/chatConfig'
import { spCorpcorpUsersList } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import date from '../../enterprise/components/date.vue'
import chhosewechatqiwei from '../../eMicroenterprise/components/chhosewechatqiwei.vue'
export default {
  name: 'Report',
  components: { PaginationRight, date, chhosewechatqiwei },
  directives: {
    numericonly: {
      bind: function(el) {
        el.addEventListener('input', function(e) {
          if (/\D/.test(e.target.value)) {
            e.target.value = e.target.value.replace(/\D/g, '')
          }
        })
      }
    },
    loadMore: {
      bind(el, binding) {
        const scroll_dom = el.querySelector('.el-scrollbar__wrap')
        scroll_dom.addEventListener('scroll', function() {
          const height = this.scrollHeight - this.scrollTop <= this.clientHeight
          if (height) {
            binding.value()
          }
        })
      }
    }
  },
  filters: {
    filterdate(val) {
      const hours = Math.floor(val / 3600)
      const minutes = Math.floor((val % 3600) / 60)
      const seconds = val % 60
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      // return dayjs(val).format('HH:mm:ss')
    }
  },
  mixins: [convertToHump],
  data() {
    return {
      // dialogVisible: false,
      selectTypeList: [],
      ChatList: [],
      showload: true,
      mode: '',
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],
      corp_primary_id: '', // 企业主键id
      status: '',
      form: {
        type: '1', // 1人2群
        chat_num_min: 10, // 聊天次数
        chat_num_max: 20,
        // conclusion: '', // 结束语
        reply_interval_min: '10', // 回复间隔
        reply_interval_max: '3600',
        communication_hour_min: 8, // 交流时间
        communication_hour_max: 22,
        proportion_personnel: 10, // 人比例
        group_type: '', // 1内部2客户
        group_room: ''
      },
      switchvalue: 1,
      loading: false,
      user: [],
      useroptions: [],
      houroptions: [],
      minutesoptions: [],
      secondsoptions: [],
      chatid: this.$route.query.corp_id || '',
      formatreply_interval_min: '',
      formatreply_interval_max: '',
      selectOptions: [
        {
          value: 1,
          label: '内部',
          disabled: false
        },
        {
          value: 2,
          label: '客户',
          disabled: true
        }
      ],
      userids: [],
      obr: {
        user_id: null,
        name: null,
        sp_strategy_no: null,
        corp_id: null,
        keywords: null
      },
      total: null,
      sp_strategy_no: null,
      rules: {
        type: [{ required: true, message: '必填', trigger: 'blur' }],
        chat_num_min: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入最小值'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (this.form.chat_num_max !== null && Number(value) >= Number(this.form.chat_num_max)) {
                callback(new Error('值不能大于等于第二个框'))
              } else {
                this.$refs.form.clearValidate('chat_num_min')
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        chat_num_max: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入最大值'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (this.form.chat_num_min !== null && Number(value) <= Number(this.form.chat_num_min)) {
                callback(new Error('值不能小于或等于第一个框'))
              } else {
                this.$refs.form.clearValidate('chat_num_max')
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        conclusion: [{ required: true, message: '请输入结束语', trigger: 'blur' }],
        reply_interval_min: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.form.formatreply_interval_max === null) {
                callback()
              } else if (value === null) {
                callback(new Error('请选择最大回复间隔'))
              } else if (this.form.formatreply_interval_max >= value) {
                callback(new Error('最小回复间隔必须小于最大回复间隔'))
              } else {
                this.$refs.form.clearValidate('reply_interval_min')
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        reply_interval_max: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.form.formatreply_interval_min === null) {
                callback()
              } else if (value === null) {
                callback(new Error('请选择最大回复间隔'))
              } else if (this.form.formatreply_interval_min >= value) {
                callback(new Error('最小回复间隔必须小于最大回复间隔'))
              } else {
                this.$refs.form.clearValidate('reply_interval_max')
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        communication_hour_min: [
          { required: true, message: '必填', trigger: 'blur' },
          { pattern: /^([1-9]\d*|0)(\.\d+)?$/, message: '交流时间最数不能小于0', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入最小值'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (this.form.communication_hour_max !== null && Number(value) >= Number(this.form.communication_hour_max)) {
                callback(new Error('值不能大于等于第二个框'))
              } else {
                this.$refs.form.clearValidate('communication_hour_min')
                callback()
              }
              if (value < 0) {
                callback(new Error('交流时间最小数不能小于0'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        communication_hour_max: [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              const regexp = /^([1-9]\d*|0)(\.\d+)?$/
              if (value === '') {
                callback(new Error('请输入最大值'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (this.form.communication_hour_min !== null && Number(value) <= Number(this.form.communication_hour_min)) {
                callback(new Error('值不能小于或等于第一个框'))
              }
              if (!regexp.test(value)) {
                callback(new Error('交流时间最大小时数必须为非负数'))
              } else if (parseFloat(value) > 23) {
                callback(new Error('交流时间最大不能大于23'))
              } else {
                this.$refs.form.clearValidate('communication_hour_max')
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        proportion_personnel: [
          { required: true, message: '请输入人数比例', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入人员占比'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (Number(value) < 0 || Number(value) > 100) {
                callback(new Error('人员占比必须在0-100之间'))
              } else {
                this.$refs.form.clearValidate('proportion_personnel')
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        group_type: [{ required: true, message: '必填', trigger: 'blur' }],
        group_room: [
          { required: true, message: '请选择群', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.group_type === '1' && !value) {
                callback(new Error('请选择一个群'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      pages: {
        page: 1,
        pageSize: 50
      },
      configshow: false,
      corp_name: '',
      corp_ids: '',
      dialogVisibleenterprise: false,
      script_online: 1,
      query: {
        page: 1,
        page_size: 10,
        keywords: null
      },
      qrtotal: null
    }
  },
  computed: {
    fullName: {
      get() {
        return this.arr.every(item => item.checked)
      },
      set(value) {
        this.arr.forEach(item => {
          item.checked = value
        })
      }
    }
  },

  beforeDestroy() {
    this.ChatList = []
  },
  created() {},
  mounted() {
    this.list()
    this.getChatList()
  },
  // activated() {
  //   this.getChatList()
  // },
  methods: {
    // 添加
    submit() {
      this.$refs.form.validate(async result => {
        if (result) {
          const minSeconds = this.form.reply_interval_min * 60
          const maxSeconds = this.form.reply_interval_max * 60
          if (minSeconds >= maxSeconds) {
            this.$message.error('回复间隔时间:第一列不能大于等于第二列时间')
            return
          }
          let user = ''
          if (!Array.isArray(this.user)) {
            const arr = this.user.split(',')
            user = [...new Set(arr)].join(',')
          } else {
            user = [...new Set(this.user)].join(',')
          }
          if (this.mode === 'add') {
            let data = {}
            // eslint-disable-next-line eqeqeq
            if (this.form.type == 2) {
              const { type, chat_num_min, chat_num_max, reply_interval_min, group_type, group_room, reply_interval_max, communication_hour_min, communication_hour_max } = this.form
              const new_group_room = group_room.join(',')
              if (group_type !== 1) {
                this.form.group_room = ''
              }
              data = {
                corp_primary_id: this.corp_primary_id,
                type,
                chat_num_min,
                chat_num_max,
                reply_interval_min,
                reply_interval_max,
                communication_hour_min,
                communication_hour_max,
                group_type,
                group_room: new_group_room
              }
              // eslint-disable-next-line eqeqeq
            } else if (this.form.type == 1) {
              console.log('user', user)
              data = {
                corp_primary_id: this.corp_primary_id,
                ...this.form,
                user,
                script_online: this.script_online
              }
            }

            await spWorkWechatSpCorpChatConfigAdd(data)
            this.$message({
              message: '添加成功',
              type: 'success'
            })
          } else if (this.mode === 'edit') {
            // this.form.group_room = this.form.group_room.join(',')
            // eslint-disable-next-line eqeqeq
            if (this.form.type == 2) {
              this.useroptions = []
              this.form.proportion_personnel = 0
              this.form = []
              // this.form.conclusion = ''
            }
            const data = {
              corp_primary_id: this.corp_primary_id,
              ...this.form,
              user,
              script_online: this.script_online
            }
            await spWorkWechatSpCorpChatConfigUpdate(data)
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          }
          this.getChatList()
          this.configshow = false
        }
      })
    },
    // 删除
    deleteConfig(scope) {
      this.$confirm('您确定删除吗')
        .then(async() => {
          const id = scope.row.id
          await spWorkWechatSpCorpChatConfigDel(id)
          this.getChatList()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        })
        .catch(() => {})
    },
    changedate(data, type) {
      if (type === 1) {
        this.form.reply_interval_min = data
      } else if (type === 2) {
        this.form.reply_interval_max = data
      }
    },
    checkNumber1() {
      const input = this.$refs.input1.$refs.input
      if (this.form.chat_num_min >= this.form.chat_num_max) {
        input.value = this.form.chat_num_max
        this.form.chat_num_min = this.form.chat_num_max
      }
    },
    // 添加
    addConfig() {
      this.showload = true
      this.mode = 'add'
      this.configshow = true
      this.getdatelist()
      // this.getuseroption()
      this.list()
      // this.getInternalGroupList()
    },
    // 内部群列表
    async getInternalGroupList(oldgroup, type) {
      const res = await spWorkWechatSpCorpInternalGroupList({ corp_id: this.$route.query.chatid, page_size: 500 })
      this.selectTypeList = res.data.list.map(i => {
        return {
          value: i.chatroom_id,
          label: i.chatroom_name
        }
      })
      if (type === 2) {
        const group = oldgroup.split(',')
        this.form.group_room = []
        this.selectTypeList.filter(item => {
          return group.forEach(items => {
            if (item.value === items) {
              this.form.group_room.push(items)
            }
          })
        })
      }
    },
    getdatelist() {
      this.houroptions = Array.from({ length: 24 }, (_, i) => i).map(i => {
        return { value: i, label: i }
      })
      this.minutesoptions = Array.from({ length: 60 }, (_, i) => i).map(i => {
        return { value: i, label: i }
      })
      this.secondsoptions = Array.from({ length: 60 }, (_, i) => i).map(i => {
        return { value: i, label: i }
      })
    },
    // 编辑
    editConfig(obj) {
      this.script_online = obj.row.script_online
      this.corp_name = obj.row.corp_name
      this.corp_ids = obj.row.corp_id

      this.form.group_type = ''
      this.form.group_type = String(obj.row.group_type)
      // this.getInternalGroupList(obj.row.group_room, 2) // 群
      this.getdatelist() // 时分秒
      this.mode = 'edit'
      this.showload = false
      const row = obj.row
      this.configshow = true
      const arr = Object.assign({}, row)
      const copy = [arr]
      const objform = copy.map(item => {
        if (item.type === 1) {
          const userid = JSON.parse(`[${obj.row.user.split(',').map(id => `"${id}"`)}]`)
          console.log(row)
          const newarr = Object.values(row.user_str).map(item => {
            return {
              name: item.name,
              id: item.employee_no,
              user_id: item.user_id
            }
          })
          this.list(userid, 2, newarr)
          // item.type = '个人'
          item.type = String(obj.row.type)
          return item
        } else if (item.type === 2) {
          console.log(row, 'row', item)
          // item.type = '群聊'
          return item
        }
        return item
      })
      this.form = Object.assign({}, objform[0])
      this.formatreply_interval_min = this.formatreply_interval_min1()
      this.formatreply_interval_max = this.formatreply_interval_max1()
      const timeString = this.formatreply_interval_min
      timeString.split(':').map(Number)
    },
    rowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 1) {
        return {
          display: 'none'
        }
      }
    },
    formatreply_interval_min1() {
      const h = Math.floor(this.form.reply_interval_min / 3600)
      const m = Math.floor((this.form.reply_interval_min - h * 3600) / 60)
      const s = this.form.reply_interval_min % 60
      return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`
    },
    formatreply_interval_max1() {
      const h = Math.floor(this.form.reply_interval_max / 3600)
      const m = Math.floor((this.form.reply_interval_max - h * 3600) / 60)
      const s = this.form.reply_interval_max % 60
      return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`
    },
    // 初次渲染列表
    async getChatList() {
      this.ChatList = []
      const res = await spWorkWechatspCorpindexForWw(this.query)
      this.ChatList = res.data.list
      this.qrtotal = res.data.total
    },
    secahclkick() {
      this.pages.page = 1
      this.list()
    },

    whole(e) {
      if (!e) {
        console.log('666')
        let index = ''
        this.arr.forEach(item => {
          if (item.checked === false) {
            console.log(item, 'item----')
            index = this.arrs.findIndex(items => {
              return items.user_id === item.user_id
            })
          }
          this.arrs.splice(index, 1)
          let list = []
          console.log('this.user:', this.user)
          if (Array.isArray(this.user)) {
            list = this.user
          } else {
            list = this.user.split(',')
          }

          this.user = list
          this.user.splice(index, 1)
          this.userids.splice(index, 1)

          // if (!Array.isArray(ids)) {
          //
          // } else {
          //   arr = ids
          // }
          // ids = arr
          // this.user = ids
        })
      } else {
        // console.log(77, '全选')
        this.arr.forEach(item => {
          if (item.checked === true) {
            this.arrs.map(re => re.user_id).includes(item.user_id) || this.arrs.push({ user_id: item.user_id, name: item.label, id: item.id })
          }
        })
      }
      this.user = [...new Set(this.arrs.map(item => item.id))]
    },
    // 点击单选
    itenclick(item, index) {
      if (item.checked === true) {
        this.arrs.push({ user_id: item.user_id, name: item.label, id: item.id })
      } else {
        const index = this.arrs.findIndex(v => v.user_id === item.user_id)
        if (index !== -1) {
          this.arrs.splice(index, 1)
        }
      }
      this.user = [...new Set(this.arrs.map(item => item.id))]
    },
    // 选中员工删除
    rightclick(user_id, index) {
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.user_id === user_id) {
          items.checked = false
        }
      })
      this.user = [...new Set(this.arrs.map(item => item.id))]
    },
    async list(userid, type, newarr) {
      this.obr.corp_id = this.$route.query.chatid
      const res = {
        ...this.pages,
        ...this.obr,
        corp_id: this.corp_ids
      }
      const data = await spCorpcorpUsersList(res)
      this.arr = data.data.list.map(item => {
        return {
          id: item.employee_no,
          label: item.name,
          checked: false,
          user_id: item.user_id
        }
      })
      this.total = data.data.total
      if (this.arrs.length > 0) {
        console.log(11222, this.arrs, this.arr)
        if (this.mode === 'add') {
          this.arrs.forEach(item => {
            this.arr.forEach(items => {
              if (item.user_id === items.user_id) {
                items.checked = true
              }
            })
          })
        } else {
          console.log('type---2', this.userids)
          this.arrs.forEach(item => {
            this.arr.forEach(items => {
              if (item.user_id === items.user_id) {
                items.checked = true
              }
            })
          })
        }
      }
      // const ids = []
      if (type === 2) {
        console.log(newarr, 'newarr')
        this.arrs = []
        newarr.filter(item => {
          this.arrs.push({
            name: item.name,
            user_id: item.user_id,
            id: item.id
          })
          // ids.push(item.id)
          this.arr.forEach(items => {
            if (items.user_id === item.user_id) {
              items.checked = true
            }
          })
        })
        this.userids = newarr
        // this.user = ids
        this.user = [...new Set(this.arrs.map(item => item.id))]
      }
    },

    // 开关
    async changewr(e, item) {
      // console.log(e, item)
      await spWorkWechatSpCorpChatConfigSetStatus({
        id: item.id,
        status: e
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.getChatList()
    },
    // 分页
    fetchPageSize(e) {
      this.pages.pageSize = e
      this.pages.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.pages.page = e
      this.list()
    },
    set(id) {
      this.arrs.forEach(item => {
        if (item.user_id === id) {
          item.tips = false
        }
      })
    },
    transformarr(arrs) {
      arrs.forEach(item => {
        const user = []
        this.obr.user.push(user)
      })
    },
    // 重置表单
    closeEvent() {
      // 清空表单数据
      this.$refs.form.resetFields()
      this.form = {
        type: '1', // 1人2群
        chat_num_min: 10, // 聊天次数
        chat_num_max: 20,
        // conclusion: '', // 结束语
        reply_interval_min: '10', // 回复间隔
        reply_interval_max: '3600',
        communication_hour_min: 8, // 交流时间
        communication_hour_max: 22,
        proportion_personnel: 10, // 人比例
        group_type: '',
        group_room: ''
      }
      this.formatreply_interval_min = ''
      this.formatreply_interval_max = ''
      this.user = ''
      this.selectTypeList = []
      this.arr = []
      this.arrs = []
      this.corp_ids = ''
      this.corp_name = ''
      this.script_online = 1
    },
    chooseEnterprise() {
      this.dialogVisibleenterprise = true
      this.$nextTick(() => {
        this.$refs.chhosewechatqiweiview.send()
      })
    },
    callbackqiwei(item) {
      this.dialogVisibleenterprise = false
      this.corp_primary_id = item.id
      this.corp_name = item.corp_name
      this.corp_ids = item.corp_id
      this.list()
      this.arr = []
      this.arrs = []
      console.log('item', item)
    },
    // 分页
    fetchPageSizeone(e) {
      this.query.page_size = e
      this.getChatList()
    },
    fetchCurrentPageone(e) {
      this.query.page = e
      this.getChatList()
    },
    searchclick() {
      this.query.page = 1
      this.getChatList()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.getChatList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}
.que_box {
  margin-top: 20px;
}
.have {
  color: #409eff;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr {
  background: #409eff;
}
.choses_box[data-v-101af6bb],
.choose_allblock[data-v-101af6bb] {
  margin-left: 50px;
}
.rigboxr {
  margin-top: 430px;
  margin-left: -172px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 310px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.choiceofficialaccount {
  margin-bottom: 10px;
}
.select_spacing {
  margin-bottom: 5px;
}
.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.name-item {
  margin-right: 10px;
}
</style>
<style scoped>
.choose_allblock[data-v-101af6bb] {
  height: 284px;
  width: 410px;
}
.addbutton {
  /* margin-bottom: 20px; */
}

.frame {
  width: 65%;
}
.conter {
  display: flex;
}
.senadtime {
  display: flex;
  align-items: center;
}
.taewr {
  display: flex;
  align-items: center;
}

.copy_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 34px;
}
.copy_boxr {
  display: flex;
  align-items: center;
}
.taewr {
  display: flex;
  align-items: center;
}
.tiwmebox {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
}
.tiwmeboxr {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 5px;
}
.ca_boxr {
  margin-right: 17px;
  width: 50px;
  text-align: right;
  color: rgb(169, 162, 151);
  font-size: 14px;
  font-weight: 700;
}
.ca_boxre {
  width: 50px;
  text-align: right;
  margin-right: 16px;
  color: rgb(169, 162, 151);
  font-size: 14px;
  font-weight: 700;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}
.tactics_box {
  padding: 20px 20px 40px 20px;
}
.sum_box {
  position: fixed;
  left: 0;
  bottom: -20px;
  margin-left: 30px;
}
.sava_box {
  position: fixed;
  bottom: 10px;
  left: 286px;
}

.senadtime {
  display: flex;
  align-items: center;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 0px;
}
.el-select-dropdown__list {
  width: 90%;
  padding: 19px 0;
  margin: 19px;
}
.el-select {
  width: 260px;
}

.vertical-line {
  border-left: 1px solid #ccc;
  height: 320px; /* 设置线条的高度 */
  margin-right: 15px;
}

.name-item {
  margin-right: 10px;
}
.checkbox-list {
  display: flex;
  flex-direction: column;
}
.el-col {
  width: auto;
}
.checkbox-item {
  margin-bottom: 5px;
}
.checkbox-list {
  width: 300px;
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #438ff7; /* 设置背景颜色为透明 */
  border-color: #438ff7; /* 设置边框颜色为透明 */
}
.column-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 20px;
  max-height: 200px; /* 设置容器最大高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
.select_boxr{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
</style>
